export class Product {
    public id: string;
    public active: boolean = true;

    public onlyForVaccinated : boolean = false;

    public name: string;
    public text: string;
    public image: string;
    public button: string;

    public name_en: string;
    public text_en: string;
    public image_en: string;
    public button_en: string;
    public image_waiting: string;

    public limit: number;
    public requirements: any[] = []

    public discount_percent: string;
    public discount_product_id: string;

    public available: boolean; //se mostra na loja
    public available_purchase: boolean; //se mostra o botao de comprar
    public available_schedule: boolean; //se mostra a programação
    public part_of: number = -1; 
    // 0 = faz parte do menu congresso
    // 1 = faz parte do menu cursos
    // 2 = faz parte do menu prova
    // 3 = faz parte do menu anuidade
    // -1 = none

    public limit_per_member: number;

    public isAnnuity: boolean;

    public created: Date;

    public deleted: boolean;

    public sponsors: any[];

    public sponsors_url: string;

    public url_schedule: string = '';

    constructor () {

     }

}

export class ProductItem {
    public id: string;
    public product_id: string;
    public product_name: string;
    public event_id: string;
    public event_name: string;
    constructor () { }
}

//remove
export class ProductPrice {
    public id: string;
    public lot_id: string;
    public category_id: string;
    public category_name: string;
    public value: number;
    constructor () { }
}

